import Card from 'react-bootstrap/Card'
import React from 'react'

const UNIVERSE = 'rgba(28,35,43,.15)'

export default class GameplanCard extends React.Component { 

	getBoxShadow() { 
		if (this.props.ignoreBoxShadow) { 
			return ''
		} else { 
			return ` 0px 0px 10px ${UNIVERSE}`
		}
	}

	render() { 
		return (
			<Card style={{...{width: this.props.width, boxShadow: this.getBoxShadow()}, ...this.props.style}}
			onClick={this.props.onClick}>
			<Card.Body>
			{this.props.title && <Card.Title>{this.props.title}</Card.Title>}
			{this.props.children}
			</Card.Body>
			</Card>
			)
	}
}